import {DashTextTitle} from './DashTitle';

export default DashTextTitle;